import { call, put, takeLatest } from "redux-saga/effects";
import {
  accessTokenAction,
  editUserAction,
  getCompanyPermissionAction,
  getUserDetailsAction,
  getUserDetailsInitialAction,
  lockUserAction,
  loginAction,
  logoutAction,
  registerMailAction,
  unloackUserAction,
  updateUserPasswordAction,
  updateUserPermissionAction,
  userRoleUpdateAction,
} from "../api/auth-action";
import {
  getToken,
  setErr,
  setUser,
  setUserLoading,
} from "../redux/app/auth/auth-slice";
import { toast } from "react-toastify";
import {
  getCompany,
  setCompanyPerMission,
} from "../redux/app/company/company-slice";

export function* loginSaga(actions) {
  const response = yield call(loginAction, actions.payload.userLoginData);

  if (response.success) {
    const tokenResp = yield call(accessTokenAction);

    yield put(
      getToken({
        token: tokenResp?.accessToken
          ? tokenResp?.accessToken
          : response?.access_Token,
      })
    );

    if (tokenResp?.accessToken) {
      actions.payload.navigate("/home");
    } else if (response.access_Token) {
      actions.payload.navigate("/home");
    }
    toast.success("Login Successfully");
  } else {
    yield put(setErr({ errmsg: response.message }));
  }
}

export function* getTokenSaga(action) {
  const tokenResp = yield call(accessTokenAction, action.payload);

  yield put(getToken({ token: tokenResp.accessToken }));
}

export function* getUserDetailSaga(actions) {
  yield put(
    setUserLoading({
      userLoading: true,
    })
  );
  const response = yield call(getUserDetailsAction, actions.payload.token);
  if (response) {
    yield put(
      setUserLoading({
        userLoading: false,
      })
    );
  }

  if (response.data) {
    yield put(setUser({ user: response.data }));
    yield put({
      type: "GET_COMPANY",
      payload: {
        token: actions.payload.token,
        companyid: response?.data?.company?._id,
      },
    });
  }
}

export function* getCompanyPermissionSaga(actions) {
  try {
    const response = yield call(getCompanyPermissionAction, actions.payload);

    if (response.data) {
      yield put(
        setCompanyPerMission({
          companyPermission: response?.data[0],
        })
      );
    }
  } catch (error) {}
}

export function* logoutSaga(actions) {
  try {
    const response = yield call(logoutAction, actions.payload);
    if (response.status === 200) {
      localStorage.clear();
      yield put(getToken({ token: "" }));
      actions.payload.navigate("/login");
      window.location.reload();
      toast.success("Logout from system successfully");
    }
  } catch (e) {}
}

export function* editUser(actions) {
  try {
    const response = yield call(editUserAction, actions.payload);
    if (response.status === 200) {
      toast.success("User Updated Successfully");
      yield put({
        type: "GET_EACH_USER",
        payload: {
          token: actions.payload.token,
          userid: actions.payload.userId,
        },
      });
    }
  } catch (e) {}
}

export function* editUserForCancelBooking(actions) {
  try {
    const response = yield call(editUserAction, actions.payload);
    if (response.status === 200) {
      yield put({
        type: "GET_EACH_USER",
        payload: {
          token: actions.payload.token,
          userid: actions.payload.userId,
        },
      });
    }
  } catch (e) {}
}

export function* editUserforbooking(actions) {
  try {
    const response = yield call(editUserAction, actions.payload);
    if (response.status === 200) {
      yield put({
        type: "GET_EACH_USER",
        payload: {
          token: actions.payload.token,
          userid: actions.payload.userId,
        },
      });
    }
  } catch (e) {}
}

export function* unLockUserSaga(actions) {
  try {
    const response = yield call(unloackUserAction, actions.payload);
    if (response.status === 200) {
      toast.success("User Unlocked Successfully");
      yield put({
        type: "GET_EACH_USER",
        payload: {
          token: actions.payload.token,
          userid: actions.payload.userId,
        },
      });
    }
  } catch (e) {}
}

export function* lockUserSaga(actions) {
  try {
    const response = yield call(lockUserAction, actions.payload);
    if (response.status === 200) {
      toast.success("User Locked Successfully");
      yield put({
        type: "GET_EACH_USER",
        payload: {
          token: actions.payload.token,
          userid: actions.payload.userId,
        },
      });
    }
  } catch (e) {}
}

export function* updatePermissionSaga(actions) {
  try {
    const response = yield call(updateUserPermissionAction, actions.payload);
    if (response.status === 200) {
      toast.success("User Permission Updated Successfully");
      yield put({
        type: "GET_EACH_USER",
        payload: {
          token: actions.payload.token,
          userid: actions.payload.userId,
        },
      });
    }
  } catch (e) {}
}

export function* registerMailSaga(actions) {
  try {
    const response = yield call(registerMailAction, actions.payload);
    if (response.status === 200) {
      toast.success("Waiting for Admin Approval");
    }
  } catch (e) {}
}

export function* updatePasswordSaga(actions) {
  try {
    const response = yield call(updateUserPasswordAction, actions.payload);
    if (response.status === 200) {
      toast.success("User Password Updated Successfully");
    }
  } catch (e) {}
}

export function* userRoleUpdateSaga(actions) {
  try {
    const response = yield call(userRoleUpdateAction, actions.payload);
    if (response.status === 200) {
      toast.success("User Role Updated Successfully");
      yield put({
        type: "GET_EACH_USER",
        payload: {
          token: actions.payload.token,
          userid: actions.payload.userId,
        },
      });
    }
  } catch (e) {}
}

export function* getUserDetailInitialSaga(actions) {
  try {
    yield call(getUserDetailsInitialAction, actions.payload);
  } catch (error) {}
}

export function* watchAuthAsync() {
  yield takeLatest("REGISTER_MAIL", registerMailSaga);
  yield takeLatest("LOGIN_USER", loginSaga);
  yield takeLatest("GET_TOKEN", getTokenSaga);
  yield takeLatest("GET_USER_DETAILS", getUserDetailSaga);
  yield takeLatest("GET_COMPANY_PERMISSION", getCompanyPermissionSaga);
  yield takeLatest("LOGOUT", logoutSaga);
  yield takeLatest("EDIT_USER", editUser);
  yield takeLatest("EDIT_USER_FOR_CANCEL_BOOKING", editUserForCancelBooking);
  yield takeLatest("EDIT_USER_FOR_BOOKING", editUserforbooking);
  yield takeLatest("UPDATE_PERMISSION", updatePermissionSaga);
  yield takeLatest("UPDATE_PASSWORD_BY_ID", updatePasswordSaga);
  yield takeLatest("UNLOCK_USER", unLockUserSaga);
  yield takeLatest("LOCK_USER", lockUserSaga);
  yield takeLatest("USER_ROLE_UPDATE", userRoleUpdateSaga);
  yield takeLatest("GET_USER_DETAILS_INITIAL", getUserDetailInitialSaga);
}
